import mqtt from "mqtt";

const connectionData = {
    hostname: "mqtt.ciright.com",
    port: 8083,
    path: "/ws",
    username: "ciright",
    password: "Ciright@123",
    protocol: "wss",
};

class MqttService {
    static client = null;
    static topic = null;

    static initializeMqtt = (topic) => {
        // console.log("connecting");
        this.client = mqtt.connect(connectionData);
        this.client.on("connect", function () {
            // console.log("connected");
        });

        this.client.on("message", (topic, payload) => {
            // console.log("Recived Message", topic, payload.toString());
        });

        this.topic = topic;
    };

    static publish = (message) => {
        this.client.publish(this.topic, message, (error) => {
            if (error) {
                console.error(error);
            }
            // console.log("sent", this.topic, message);
        });
    };
}

export default MqttService;
